import { Component, Input } from '@angular/core';
import {
  Property,
  SectionConfig,
} from '../../../../dto/response/template.config';
import { TemplateConfigService } from '../../../../service/template-config.service';

@Component({
  selector: 'app-sub-footer',
  standalone: true,
  imports: [],
  templateUrl: './sub-footer.component.html',
  styleUrl: './sub-footer.component.scss',
})
export class SubFooterComponent {
  paymentOption: Property | undefined;
  _config!: SectionConfig;
  copyright: Property | undefined;

  constructor(private templateConfigService: TemplateConfigService) {}

  @Input()
  set subFooterConfig(config: SectionConfig) {
    this._config = config;
    this.paymentOption = this.templateConfigService.findConfig(config, 'trust');
    this.copyright = this.templateConfigService.findConfig(config, 'copyright');
  }
}
